"use strict";

var _createClass = require("/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * A `Layout` defines the structure of a graph layout optimization procedure. It allows both
 * executing the entire procedure automatically and stepping through the procedure manually.
 */

var Layout = function Layout(storage) {
  _classCallCheck(this, Layout);

  this.storage = storage;
};

exports.Layout = Layout;
/**
 * A `StagedLayout` performs a fixed number of optimization steps, where each step involved
 * executing all stages of a computation. A single stage uses a generator function to generate
 * gradients, which optimizer applies. Each stage may be repeated for a different fixed number
 * of iterations.
 */

var StagedLayout =
/*#__PURE__*/
function (_Layout) {
  _inherits(StagedLayout, _Layout);

  function StagedLayout(storage, _ref) {
    var _this;

    var _ref$steps = _ref.steps,
        steps = _ref$steps === void 0 ? 1 : _ref$steps,
        _ref$onStart = _ref.onStart,
        onStart = _ref$onStart === void 0 ? function () {
      return true;
    } : _ref$onStart,
        _ref$onStep = _ref.onStep,
        onStep = _ref$onStep === void 0 ? function () {
      return true;
    } : _ref$onStep,
        _ref$onEnd = _ref.onEnd,
        onEnd = _ref$onEnd === void 0 ? function () {
      return undefined;
    } : _ref$onEnd;

    _classCallCheck(this, StagedLayout);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(StagedLayout).call(this, storage));
    _this.onStart = onStart;
    _this.onStep = onStep;
    _this.onEnd = onEnd;

    for (var _len = arguments.length, stages = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      stages[_key - 2] = arguments[_key];
    }

    _this.stages = stages;
    _this._totalSteps = steps;
    _this._finishedSteps = 0;
    return _this;
  }

  _createClass(StagedLayout, [{
    key: "start",
    value: function start() {
      var onStart = this.onStart,
          onEnd = this.onEnd;
      if (!onStart(this.storage, this._finishedSteps)) return;

      while (this._finishedSteps < this._totalSteps) {
        var proceed = this.step(); // If break out early, do not trigger `onEnd`.

        if (!proceed) return;
      }

      onEnd(this.storage, this._finishedSteps);
    }
  }, {
    key: "step",
    value: function step() {
      var onStep = this.onStep;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.stages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var stage = _step.value;

          for (var i = 1; i <= stage.iterations; i++) {
            var gen = stage.generator(this.storage, this._finishedSteps, i);
            var grads = void 0;

            while (true) {
              // Must use manual iteration, not for-of loop, in order to access return value.
              grads = gen.next();
              if (grads.value) stage.optimizer.step(grads.value);
              if (grads.done) break;
            }

            stage.optimizer.update();
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this._finishedSteps += 1;
      return onStep(this.storage, this._finishedSteps);
    }
  }]);

  return StagedLayout;
}(Layout);

exports.StagedLayout = StagedLayout;